import BookAnAppointmentMbm from '@moncler/components/appointments/BookAnAppointmentMbm';
import ContactDetailsEnhanced from '@moncler/components/clientService/ContactDetailsEnhanced';
import MbmIcons from '@moncler/components/mbm/MbmIcons';
import MbmNotifyMeModal from '@moncler/components/mbm/MbmNotifyMeModal';
import MbmOOSBox from '@moncler/components/mbm/MbmOOSBox';
import MbmShippingDelivery from '@moncler/components/mbm/MbmShippingDelivery';
import ProductPrice from '@moncler/components/product/ProductPrice';
import ProductReserveInBoutique from '@moncler/components/reserve/ProductActionReserveInBoutique';
import analytics from '@utils/analytics';
import api from '@utils/api';
import { getColorVariations, getSizeVariations, getSimilarProducts } from '@utils/product';
import useBreakpoint from '@utils/useBreakpoint';
import classNames from 'classnames';
import React, { Suspense, useCallback, useEffect, useMemo, useRef, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { useInView } from 'react-intersection-observer';
import { useSelector } from 'react-redux';
import { useHistory, useParams } from 'react-router-dom';
import NFTInfoBox from './NFTInfoBox';
import ShowSimilarProductInline from '@moncler/components/product/ShowSimilarProductInline';
import ShowSimilarProductFloating from '@moncler/components/product/ShowSimilarProductFloating';
import SimilarProductsDrawer from '@moncler/components/product/SimilarProductsDrawer';
import ProductButton from './ProductButton';
import ProductLabels from './ProductLabels';
import ProductSelectionSizesExpanded from './ProductSelectionSizesExpanded';
import ProductStickyTray from './ProductStickyTray';
import ProductWishlistToggle from './ProductWishlistToggle';
import Drawers from '@common/ui/drawes/Drawers';
import useResizeObserver from '@common/utils/useMutationObservable';
import useInnerWidth from '@utils/useInnerWidth';
import LoginModal from '@components/login/LoginModal';
import { freeExpressShippingCustomerGroup } from '@utils/constants';
import customEventBus from '@common/scripts/libs/eventBus';
import cookie from 'react-cookies';
import ProductSelectionColorExpandedLinks from './ProductSelectionColorExpandedLinks';
const ExpressPaymentsModal = React.lazy(() => import('@components/bag/ExpressPaymentsModal'));
let colorChanged = false;
const ProductSelection = (props) => {
    var _a, _b, _c, _d, _e, _f, _g, _h;
    let { pid } = useParams();
    let current;
    const inLook = !!props.currentLook;
    if (inLook) {
        current = props.currentLook;
    }
    else {
        current = useSelector((state) => state.product).current;
    }
    const { t } = useTranslation();
    const currentBreakpoint = useBreakpoint();
    const currentWidth = useInnerWidth();
    const variantSizeObj = useMemo(() => (props.size ? JSON.parse(props.size) : undefined), [props.size]);
    const [variantPrice, setVariantPrice] = useState(((_b = (_a = variantSizeObj === null || variantSizeObj === void 0 ? void 0 : variantSizeObj.price) === null || _a === void 0 ? void 0 : _a.sales) === null || _b === void 0 ? void 0 : _b.value) ? variantSizeObj.price : undefined);
    const history = useHistory();
    const productSectionRef = useRef();
    const productButtonRef = useRef();
    const [showSticky, setShowSticky] = useState(false);
    const [mbmNotify, setMbmNotify] = useState(false);
    // const [collectionsModalOpen, setCollectionsModalOpen] = useState<boolean>(false);
    const [contactusModalOpen, setContactusModalOpen] = useState(false);
    const [similarModalOpen, setSimilarModalOpen] = useState(false);
    const [promotionInfo, setPromotionInfo] = useState();
    const [campaignActive, setCampaingActive] = useState(false);
    const [hasFreeExpressShipping, setHasFreeExpressShipping] = useState(false);
    const [loginOpen, setLoginOpen] = useState(false);
    const [similarFloatingVisible, setSimilarFloatingVisible] = useState(true);
    const [visibilityFloatingModule, setVisibilityFloatingModule] = useState(false);
    const [enableSimilarButton, setEnableSimilarButton] = useState(false);
    const [similarProductsTiles, setSimilarProductsTiles] = useState(null);
    const floatingShowTimer = useRef();
    const isGrenoble = (_c = current === null || current === void 0 ? void 0 : current.collections) === null || _c === void 0 ? void 0 : _c.grenoble;
    const isGenius = ((_d = current === null || current === void 0 ? void 0 : current.collections) === null || _d === void 0 ? void 0 : _d.genius) && !isGrenoble;
    const isPreorder = (_e = current === null || current === void 0 ? void 0 : current.availability) === null || _e === void 0 ? void 0 : _e.preorder;
    const isMobile = currentBreakpoint < parseInt(window.mqObj.md.toString());
    const isPreOrderOrExclusive = ((_h = (_g = (_f = current === null || current === void 0 ? void 0 : current.variationAttributes) === null || _f === void 0 ? void 0 : _f.find((va) => va.id == 'color')) === null || _g === void 0 ? void 0 : _g.values) === null || _h === void 0 ? void 0 : _h.some((va) => va.preorderable)) || (current === null || current === void 0 ? void 0 : current.isBoutiqueExclusive);
    const colourVariations = useMemo(() => {
        let colors;
        colors = getColorVariations(current).map((value) => {
            return Object.assign(Object.assign({}, value), { groupPid: (current === null || current === void 0 ? void 0 : current.masterId) + value.id });
        });
        if (inLook) {
            // non è possibile selezionare altri colori nel look
            colors = colors.filter((value) => value.selected);
        }
        return colors;
    }, [current, inLook]);
    const [currentSize, setCurrentSize] = useState();
    const [currentColor, setCurrentColor] = useState();
    const [sizeSelectorError, setSizeSelectorError] = useState(false);
    const sizeVariations = useMemo(() => {
        let sizeVariations = getSizeVariations(current);
        if (sizeVariations.length == 1) {
            setCurrentSize(sizeVariations[0]);
        }
        else if (sizeVariations.find((el) => el.displayValue == (variantSizeObj === null || variantSizeObj === void 0 ? void 0 : variantSizeObj.size))) {
            setCurrentSize(sizeVariations.find((el) => el.displayValue == variantSizeObj.size));
        }
        else if (!sizeVariations.find((el) => el.id == (currentSize === null || currentSize === void 0 ? void 0 : currentSize.id))) {
            setCurrentSize(undefined);
        }
        // console.info('nascondo il messaggio di errore');
        setSizeSelectorError(false);
        return sizeVariations;
    }, [current]);
    const isOutOfStock = useMemo(() => {
        var _a;
        return (_a = current === null || current === void 0 ? void 0 : current.availability) === null || _a === void 0 ? void 0 : _a.isOutOfStock;
    }, [current]);
    const showReserveInBoutiqueButton = useMemo(() => !window.noboutiqueavailability &&
        !(current === null || current === void 0 ? void 0 : current.isOnlineExclusive) &&
        ((current === null || current === void 0 ? void 0 : current.notShoppable) || isOutOfStock || (current === null || current === void 0 ? void 0 : current.isBoutiqueExclusive)) &&
        (!(current === null || current === void 0 ? void 0 : current.isComingSoonAutomatic) || (current === null || current === void 0 ? void 0 : current.forceSoldOut)), [currentSize, current]);
    const showReserveInBoutiqueLink = useMemo(() => {
        var _a;
        return !window.unshoppable &&
            !window.noboutiqueavailability &&
            !window.isClothing &&
            !showReserveInBoutiqueButton &&
            !inLook &&
            !(current === null || current === void 0 ? void 0 : current.isOnlineExclusive) &&
            !(current === null || current === void 0 ? void 0 : current.isComingSoon) &&
            !(current === null || current === void 0 ? void 0 : current.isMbm) &&
            !((_a = current === null || current === void 0 ? void 0 : current.availability) === null || _a === void 0 ? void 0 : _a.preorder);
    }, [showReserveInBoutiqueButton, current]);
    const expressCheckoutAvailable = useMemo(() => {
        var _a, _b, _c;
        return (window.expressCheckoutPDP &&
            !window.isClothing &&
            !window.unshoppable &&
            !(current === null || current === void 0 ? void 0 : current.isBoutiqueExclusive) &&
            !isOutOfStock &&
            (current === null || current === void 0 ? void 0 : current.isComingSoon) != 2 &&
            !(current === null || current === void 0 ? void 0 : current.notShoppable) &&
            !(current === null || current === void 0 ? void 0 : current.isMbm) &&
            (((_a = current === null || current === void 0 ? void 0 : current.price) === null || _a === void 0 ? void 0 : _a.type) || ((_c = (_b = current === null || current === void 0 ? void 0 : current.price) === null || _b === void 0 ? void 0 : _b.sales) === null || _c === void 0 ? void 0 : _c.value)) &&
            !inLook);
    }, [current, currentSize]);
    useEffect(() => {
        if (currentColor && currentSize) {
            onSizeSelection(currentSize.id);
        }
    }, [currentColor]);
    useEffect(() => {
        const colorSelected = getColorVariations(current).find((v) => v.selected);
        if (colorSelected) {
            setCurrentColor(colorSelected);
            if (colorChanged) {
                colorChanged = false;
                analytics.colorSelection(colorSelected === null || colorSelected === void 0 ? void 0 : colorSelected.value, current === null || current === void 0 ? void 0 : current.masterId, props.tileType);
            }
        }
        setContactusModalOpen(false);
        setSimilarModalOpen(false);
        setVisibilityFloatingModule(false);
        checkSimilarRecommender();
    }, [current]);
    useEffect(() => {
        floatingVisibility();
    }, [props.isScrolled]);
    // Quicker reaction compared to listening to 'current'
    useEffect(() => {
        setVisibilityFloatingModule(false);
        setEnableSimilarButton(false);
        setSimilarProductsTiles(null);
        clearTimeout(floatingShowTimer.current);
    }, [pid]);
    useEffect(() => {
        if (current) {
            let wrapperContainer = document.querySelector('.product-selection');
            let heightTarget = `calc(100vh - ${(wrapperContainer === null || wrapperContainer === void 0 ? void 0 : wrapperContainer.offsetHeight) / 10}rem`;
            let productSelection = document.querySelector('.product-selection');
            productSelection.style.top = heightTarget;
        }
        window.gbotNormalizer();
    }, [current]);
    useEffect(() => {
        api.getPromotionInfo().then((data) => {
            var _a, _b;
            setPromotionInfo(data);
            if ((_a = data.activeCampaigns) === null || _a === void 0 ? void 0 : _a.includes(window.promoFreeExpressShippingNewMembers)) {
                setCampaingActive(true);
            }
            if ((_b = data.customerGroups) === null || _b === void 0 ? void 0 : _b.includes(freeExpressShippingCustomerGroup)) {
                setHasFreeExpressShipping(true);
            }
        });
    }, []);
    const floatingVisibility = () => {
        const floatingCookieOnClose = cookie.load('sfcc_floatingSimilarClosed');
        const showFloatingModuleCondition = currentBreakpoint < 1024 || window.appmode;
        if (showFloatingModuleCondition && !floatingCookieOnClose && window.scrollY > 0) {
            floatingShowTimer.current = setTimeout(() => {
                setVisibilityFloatingModule(true);
                setSimilarTiles();
            }, 5000);
        }
    };
    useEffect(() => {
        var _a, _b;
        if (currentSize && ((_b = (_a = current.variationAttributes[1]) === null || _a === void 0 ? void 0 : _a.values) === null || _b === void 0 ? void 0 : _b.length) > 1) {
            analytics.productDetailChange(current, currentSize);
        }
    }, [currentSize]);
    const changeColor = (colorVariation) => {
        if (!colorVariation) {
            return;
        }
        if (!inLook) {
            colorChanged = true;
            history.push(colorVariation.route);
            if (props.setPlayButtonVideo) {
                props.setPlayButtonVideo();
            }
        }
    };
    const changeFormat = (formatVariation) => {
        changeSize(formatVariation);
        window.location.href = formatVariation.url;
    };
    const triggerSizeSelectionOpen = () => {
        customEventBus.emit('size-selector:open', {});
    };
    const changeSize = (variation) => {
        setCurrentSize(variation);
        // qui non va cambiato il prodotto, va solo salvata la taglia selezionata che serve per l'add to cart
        if ((current === null || current === void 0 ? void 0 : current.price.type) === 'range') {
            // prezzo diverso per taglia
            api.variantPrice(`${current === null || current === void 0 ? void 0 : current.masterId}${currentColor.id}${variation.id}`).then((data) => {
                const priceData = data && Object.keys(data).length ? data : undefined;
                setVariantPrice(priceData);
            });
        }
    };
    const onSizeSelection = (size) => {
        if (size) {
            let sizeVariation = sizeVariations.find((s) => s.id == size);
            if (sizeVariation) {
                changeSize(sizeVariation);
            }
        }
    };
    const shippingDisclaimer = () => {
        return (React.createElement("div", { className: "product-selection__shipping-disclaimer" },
            React.createElement("p", { className: "shipping-disclaimer__title" }, t('expressshippingfree.title')),
            React.createElement("div", { className: "shipping-disclaimer_description" },
                React.createElement("span", null,
                    t('expressshippingfree.description'),
                    " "),
                (promotionInfo === null || promotionInfo === void 0 ? void 0 : promotionInfo.guest) && (React.createElement(LoginModal, { incontext: "membersonly", modalStatus: loginOpen, reloadPage: true, updateStatus: (status) => setLoginOpen(status), linkText: t('expressshippingfree.loginbutton'), customClass: "button--link-button" })))));
    };
    const lineIcons = () => {
        var _a, _b;
        return (React.createElement(React.Fragment, null,
            isGrenoble && React.createElement("span", { className: "icon--grenoble" }),
            isGenius && React.createElement("span", { className: "icon--genius" }),
            (current === null || current === void 0 ? void 0 : current.isMbm) && ((_a = current === null || current === void 0 ? void 0 : current.mbm) === null || _a === void 0 ? void 0 : _a.label) && React.createElement("img", { src: (_b = current === null || current === void 0 ? void 0 : current.mbm) === null || _b === void 0 ? void 0 : _b.label, alt: t('mbm.title'), className: "mbm-label" })));
    };
    const lineIconsContainer = (className) => {
        var _a, _b, _c, _d;
        const breadcrumbs = (current === null || current === void 0 ? void 0 : current.breadcrumbs) || [];
        return (React.createElement("div", { className: className },
            React.createElement("div", { className: "product-selection__line-name" }, (breadcrumbs === null || breadcrumbs === void 0 ? void 0 : breadcrumbs.length) > 1 ? (React.createElement(React.Fragment, null, breadcrumbs.slice(1, breadcrumbs.length).map((e) => (React.createElement("a", { className: !inLook ? 'in-pdp' : '', key: e === null || e === void 0 ? void 0 : e.categoryId, href: e.url }, e.htmlValue))))) : (React.createElement("a", { className: !inLook ? 'in-pdp' : '', key: (_a = breadcrumbs[0]) === null || _a === void 0 ? void 0 : _a.categoryId, href: (_b = breadcrumbs[0]) === null || _b === void 0 ? void 0 : _b.url }, (_c = breadcrumbs[0]) === null || _c === void 0 ? void 0 : _c.htmlValue))),
            !inLook && (React.createElement("div", { className: "product-selection__line-labels", id: "product-info-heading" },
                React.createElement(ProductLabels, { product: current, inLook: inLook, href: (_d = breadcrumbs[0]) === null || _d === void 0 ? void 0 : _d.url })))));
    };
    const sendAnalytics = () => {
        var _a, _b, _c;
        if ((_c = (_b = (_a = current.variationAttributes) === null || _a === void 0 ? void 0 : _a.find((va) => va.id == 'color')) === null || _b === void 0 ? void 0 : _b.values.find((va) => va.selected)) === null || _c === void 0 ? void 0 : _c.preorderable) {
            analytics.preorder(current === null || current === void 0 ? void 0 : current.masterId);
            analytics.preorderDetail(current, currentSize, variantPrice || (current === null || current === void 0 ? void 0 : current.price));
        }
        else {
            analytics.addToBag(current, currentSize, variantPrice || (current === null || current === void 0 ? void 0 : current.price));
        }
    };
    const sizeError = useMemo(() => {
        if (sizeSelectorError && !currentSize) {
            return t('label.pleaseselectasize');
        }
    }, [sizeSelectorError, currentSize, current === null || current === void 0 ? void 0 : current.availability]);
    // const isOutOfStock = useMemo(() => {
    //   if (
    //     (currentSize?.ATS < 1 || isOutOfStock) &&
    //     !current?.isBoutiqueExclusive &&
    //     !currentSize?.isOnlineExclusive &&
    //     (current?.isComingSoon !== 2 || current?.forceSoldOut)
    //   ) {
    //     return (
    //       <div className="selector__error">
    //         <span className="errormessage primary-xxs" role="alert">
    //           {t(
    //             colourVariations.find((colour) => {
    //               if (colour.selectable) {
    //                 return true;
    //               }
    //               return false;
    //             })
    //               ? 'label.itemoutofstocksize'
    //               : 'label.outofstocksizeandcolour'
    //           )}
    //         </span>
    //       </div>
    //     );
    //   }
    // }, [sizeSelectorError, currentSize, current?.availability]);
    const checkSimilarRecommender = () => {
        var _a, _b;
        if (showSimilarProducts) {
            const similarProductConfig = (_a = current === null || current === void 0 ? void 0 : current.limitedAvailabilityConfig) === null || _a === void 0 ? void 0 : _a.similarProductConfig;
            const usingRecommender = similarProductConfig === null || similarProductConfig === void 0 ? void 0 : similarProductConfig.useRecommender;
            const isManualConfig = (_b = similarProductConfig === null || similarProductConfig === void 0 ? void 0 : similarProductConfig.productIdList) === null || _b === void 0 ? void 0 : _b.length;
            if (usingRecommender && !isManualConfig) {
                setSimilarTiles();
            }
            else {
                setEnableSimilarButton(true);
            }
        }
    };
    const setSimilarTiles = async () => {
        return getSimilarProductsTiles().then((data) => {
            setSimilarProductsTiles(data);
            setEnableSimilarButton((data === null || data === void 0 ? void 0 : data.length) > 0);
            return data;
        });
    };
    const getSimilarProductsTiles = async () => {
        return new Promise((resolve, reject) => {
            if (similarProductsTiles === null || similarProductsTiles === void 0 ? void 0 : similarProductsTiles.length) {
                return resolve(similarProductsTiles);
            }
            else if (!similarProductsTiles) {
                // We only fetch if it's null, we don't ask again if we already got an empty array
                return fetchSimilarProductsTiles().then((data) => {
                    resolve(data);
                });
            }
        });
    };
    const fetchSimilarProductsTiles = async () => {
        return getSimilarProducts(current)
            .then((data) => {
            return data;
        })
            .catch(() => {
            return [];
        });
    };
    const openSimilarModal = () => {
        setSimilarTiles().then((data) => {
            setSimilarModalOpen(true);
            analytics.productImpressionsRecommended(data, 'pdp');
            analytics.seeSimilarProducts(current === null || current === void 0 ? void 0 : current.masterId);
        });
    };
    const showSimilarProducts = useMemo(() => {
        var _a;
        const isPreorderOrBoutiqueExclusive = (current === null || current === void 0 ? void 0 : current.isBoutiqueExclusive) || isPreorder;
        if ((!(current === null || current === void 0 ? void 0 : current.hasLimitedAvailability) && !(current === null || current === void 0 ? void 0 : current.isComingSoon)) || isPreorderOrBoutiqueExclusive) {
            return false;
        }
        const limitedAvailabilityConfig = current === null || current === void 0 ? void 0 : current.limitedAvailabilityConfig;
        const similarProductConfig = limitedAvailabilityConfig === null || limitedAvailabilityConfig === void 0 ? void 0 : limitedAvailabilityConfig.similarProductConfig;
        const hasSimilarProducts = (similarProductConfig === null || similarProductConfig === void 0 ? void 0 : similarProductConfig.useRecommender) ? similarProductConfig.recommenderId : (_a = similarProductConfig === null || similarProductConfig === void 0 ? void 0 : similarProductConfig.productIdList) === null || _a === void 0 ? void 0 : _a.length;
        return (limitedAvailabilityConfig === null || limitedAvailabilityConfig === void 0 ? void 0 : limitedAvailabilityConfig.showSimilarProducts) && !!hasSimilarProducts;
    }, [current, isPreorder]);
    const showSimilarProductsFloating = useMemo(() => {
        return showSimilarProducts && similarFloatingVisible;
    }, [showSimilarProducts, similarFloatingVisible]);
    const showSimilarProductsInline = useMemo(() => {
        return showSimilarProducts && !isOutOfStock;
    }, [showSimilarProducts, isOutOfStock]);
    // const showNotifyMobile = useMemo(() => {
    //   if (currentBreakpoint >= window.mqObj.md) {
    //     return false; // not mobile
    //   }
    //   if (!current?.price?.type && !current?.price?.sales?.value) {
    //     return false; // no price
    //   }
    //   return (currentSize && !currentSize?.selectable) || isOutOfStock || current?.notShoppable;
    // }, [currentBreakpoint, current, currentSize]);
    const productSelectionBody = () => {
        var _a, _b, _c, _d, _e, _f, _g, _h, _j, _k, _l, _m, _o, _p, _q, _r;
        if (!current) {
            return React.createElement(React.Fragment, null);
        }
        return (React.createElement(React.Fragment, null,
            React.createElement("div", { className: "product-selection__top-half" },
                React.createElement("div", { className: "product-selection__heading--placeholder" },
                    React.createElement("div", { className: "product-selection__heading" },
                        (!inLook || (current === null || current === void 0 ? void 0 : current.unlock)) && lineIconsContainer('product-selection__line'),
                        React.createElement("div", { className: "product-selection__name-price" },
                            React.createElement("h1", { className: "product-selection__name-price__name" }, current === null || current === void 0 ? void 0 : current.productName),
                            React.createElement("span", { className: classNames(current.isGiftCard ? 'd-md-block d-none' : '', 'product-selection__name-price__price') }, (current === null || current === void 0 ? void 0 : current.isGiftCard) ? React.createElement(ProductPrice, { basePrice: ((_b = (_a = current === null || current === void 0 ? void 0 : current.gcLimits) === null || _a === void 0 ? void 0 : _a.minValue) === null || _b === void 0 ? void 0 : _b.formattedValue) || '' }) : React.createElement(ProductPrice, { price: variantPrice || (current === null || current === void 0 ? void 0 : current.price) })),
                            currentBreakpoint < window.mqObj.md && currentColor && !(current === null || current === void 0 ? void 0 : current.isMbm) && !(props === null || props === void 0 ? void 0 : props.currentLook) && (React.createElement(ProductWishlistToggle, { modifierClass: "--mobile", color: "black", productSize: currentSize, productColor: currentColor, product: current, section: "pdp" }))))),
                React.createElement("div", { className: "product-selection__description" },
                    React.createElement("p", null, (current === null || current === void 0 ? void 0 : current.longDescription) || (current === null || current === void 0 ? void 0 : current.shortDescription)),
                    current.additionalShortDescription && React.createElement("p", { dangerouslySetInnerHTML: { __html: current.additionalShortDescription }, className: "mt-16" })),
                current.isGiftCard && (React.createElement("div", { className: "gc-havecard" },
                    t('gc.haveacard'),
                    " ",
                    React.createElement("button", { onClick: () => props.openBalance() }, t('gc.checkbalance')))),
                ((_c = current === null || current === void 0 ? void 0 : current.availability) === null || _c === void 0 ? void 0 : _c.preorder) && ((_d = current === null || current === void 0 ? void 0 : current.availability) === null || _d === void 0 ? void 0 : _d.inStockDate) && (React.createElement("div", { className: "product-selection__preorder mt-12", dangerouslySetInnerHTML: { __html: t('product.shippingby', { 0: (_e = current === null || current === void 0 ? void 0 : current.availability) === null || _e === void 0 ? void 0 : _e.inStockDate }) } })),
                React.createElement("button", { "aria-haspopup": "dialog", onClick: () => {
                        analytics.detailsAndCare('', currentColor === null || currentColor === void 0 ? void 0 : currentColor.productId);
                        props.setDetailsOpen(true);
                    }, className: classNames('link-anchor', { 'no-margin-bottom': (current === null || current === void 0 ? void 0 : current.isMbm) && ((_f = current.mbm) === null || _f === void 0 ? void 0 : _f.icons) }) }, current.isGiftCard ? t('gc.howitworks') : t('anchor.description')),
                current.isGiftCard && (React.createElement("div", { className: "gc-icons" },
                    React.createElement("div", null,
                        React.createElement("div", { className: "gc-icon-amount" }),
                        React.createElement("p", null, t('gc.chooseamount'))),
                    React.createElement("div", null,
                        React.createElement("div", { className: "gc-icon-onlinestore" }),
                        React.createElement("p", null, t('gc.onlineandstore'))),
                    React.createElement("div", null,
                        React.createElement("div", { className: "gc-icon-deliverydate" }),
                        React.createElement("p", null, t('gc.deliverydate'))),
                    React.createElement("div", null,
                        React.createElement("div", { className: (current === null || current === void 0 ? void 0 : current.gcConfigValidity) ? `gc-icon-validity--${current === null || current === void 0 ? void 0 : current.gcConfigValidity}` : 'gc-icon-validity--unlimited' }),
                        React.createElement("p", null, (current === null || current === void 0 ? void 0 : current.gcConfigValidity) ? t('gc.useforyears', `Use it for ${current === null || current === void 0 ? void 0 : current.gcConfigValidity} years`, { 0: current === null || current === void 0 ? void 0 : current.gcConfigValidity }) : t('gc.useforunlimited'))))),
                (current === null || current === void 0 ? void 0 : current.isMbm) && ((_g = current.mbm) === null || _g === void 0 ? void 0 : _g.icons) && React.createElement(MbmIcons, { icons: (_h = current === null || current === void 0 ? void 0 : current.mbm) === null || _h === void 0 ? void 0 : _h.icons })),
            React.createElement("div", { className: "product-selection__bottom-half" },
                !(current === null || current === void 0 ? void 0 : current.isMbm) && !current.isGiftCard && (React.createElement("div", { className: classNames('product-selection__wrapper', { 'on-pdp': !inLook }) },
                    React.createElement(React.Fragment, null,
                        React.createElement(ProductSelectionColorExpandedLinks, { variationValues: colourVariations, current: current, currentId: currentColor === null || currentColor === void 0 ? void 0 : currentColor.id, onChangeVariation: (colorVariation) => {
                                changeColor(colorVariation);
                            }, productUuid: current.masterId, inverted: props.inverted, isBoutiqueExclusive: current === null || current === void 0 ? void 0 : current.isBoutiqueExclusive }),
                        React.createElement(ProductSelectionSizesExpanded, { contactformurl: props === null || props === void 0 ? void 0 : props.contactformurl, variationValues: sizeVariations, current: current, currentId: currentSize === null || currentSize === void 0 ? void 0 : currentSize.id, currentSize: currentSize, onChangeVariation: (sizeVariation) => {
                                if (sizeVariation.isParfum) {
                                    changeFormat(sizeVariation);
                                }
                                else {
                                    changeSize(sizeVariation);
                                    analytics.selectedSize(sizeVariation === null || sizeVariation === void 0 ? void 0 : sizeVariation.displayValue, current === null || current === void 0 ? void 0 : current.masterId);
                                }
                            }, error: sizeError, trackOpenSize: () => analytics.openSize(current === null || current === void 0 ? void 0 : current.masterId), onSizeSelection: onSizeSelection, setSizeguideOpen: props === null || props === void 0 ? void 0 : props.setSizeguideOpen, openSimilarModal: openSimilarModal, similarProductsTiles: similarProductsTiles, sizeguideOpen: props === null || props === void 0 ? void 0 : props.sizeguideOpen, inverted: props.inverted, showSizeFit: true, comboBox: true }),
                        React.createElement("div", { id: "size-selector-combobox-container" }),
                        showSimilarProductsInline && ((similarProductsTiles === null || similarProductsTiles === void 0 ? void 0 : similarProductsTiles.length) > 0 || enableSimilarButton) && (React.createElement(ShowSimilarProductInline, { enabled: enableSimilarButton, setSimilarModalOpen: openSimilarModal })),
                        visibilityFloatingModule && showSimilarProductsFloating && (similarProductsTiles === null || similarProductsTiles === void 0 ? void 0 : similarProductsTiles.length) > 0 && (React.createElement(ShowSimilarProductFloating, { product: current, onFloatingClose: () => {
                                setSimilarFloatingVisible(false);
                                cookie.save('sfcc_floatingSimilarClosed', 'true', { path: '/', maxAge: 1800 });
                            }, similarProductsTiles: similarProductsTiles })),
                        (similarProductsTiles === null || similarProductsTiles === void 0 ? void 0 : similarProductsTiles.length) > 0 && (React.createElement(SimilarProductsDrawer, { similarModalOpen: similarModalOpen, setSimilarModalOpen: setSimilarModalOpen, product: current, similarProductsTiles: similarProductsTiles }))))),
                React.createElement(React.Fragment, null,
                    React.createElement("div", { ref: productButtonRef, className: classNames('product-selection__ctas', { 'is-mbm': current === null || current === void 0 ? void 0 : current.isMbm }, { 'last-cta': expressCheckoutAvailable && (((current === null || current === void 0 ? void 0 : current.unlock) && window.loggedin) || !current.unlock) }) },
                        React.createElement(ProductButton, { inPDP: props.inPDP, current: current, currentSize: currentSize, currentColor: currentColor, colourVariations: colourVariations, sizeVariations: sizeVariations, triggerOpenSize: triggerSizeSelectionOpen, trackAddToBag: sendAnalytics, showReserveInBoutiqueButton: showReserveInBoutiqueButton, inShopTheLook: props.shopTheLook, inverted: props.inverted }),
                        currentColor && !(current === null || current === void 0 ? void 0 : current.isMbm) && !(props === null || props === void 0 ? void 0 : props.currentLook) && (React.createElement(ProductWishlistToggle, { color: "black", productSize: currentSize, productColor: currentColor, product: current, section: "pdp" }))),
                    current.isGiftCard && (React.createElement("div", { className: "d-flex gc-return-info" },
                        React.createElement("p", null, t('gc.notreturnable')),
                        React.createElement("a", { href: current.giftCardTermsURL || 'https://www.moncler.com' }, t('gc.learnmore')))),
                    expressCheckoutAvailable && (((current === null || current === void 0 ? void 0 : current.unlock) && window.loggedin) || !current.unlock) && (React.createElement("div", { className: "product-selection__ctas express-payments" },
                        React.createElement(Suspense, { fallback: React.createElement(React.Fragment, null) },
                            React.createElement(ExpressPaymentsModal, { currentId: current.id, size: currentSize, triggerOpenSize: triggerSizeSelectionOpen, checkouturl: props.checkouturl }))))),
                (current === null || current === void 0 ? void 0 : current.isMbm) && !isOutOfStock && React.createElement(MbmShippingDelivery, { onPDP: true, faqLink: (_j = current === null || current === void 0 ? void 0 : current.mbm) === null || _j === void 0 ? void 0 : _j.returnFaq }),
                (current === null || current === void 0 ? void 0 : current.isMbm) && isOutOfStock && (React.createElement(React.Fragment, null,
                    React.createElement(MbmOOSBox, { onClick: () => {
                            analytics.notifyMe(current === null || current === void 0 ? void 0 : current.id, 'pdp', true);
                            setMbmNotify(true);
                        } }),
                    React.createElement(MbmNotifyMeModal, { isOpen: mbmNotify, onRequestClose: () => setMbmNotify(false), imgs: current === null || current === void 0 ? void 0 : current.imgs, editLink: (_k = current === null || current === void 0 ? void 0 : current.mbm) === null || _k === void 0 ? void 0 : _k.toConfigurator, productId: current.id }))),
                React.createElement("div", { className: classNames('product-selection__actions-shipping', { 'on-pdp': !inLook }, !promotionInfo || !campaignActive || (window.loggedin && !hasFreeExpressShipping) ? '' : 'shipping-disclaimer-active') },
                    !current.isGiftCard &&
                        (!promotionInfo || !campaignActive || (window.loggedin && !hasFreeExpressShipping) ? (React.createElement(React.Fragment, null, !window.unshoppable &&
                            !(current === null || current === void 0 ? void 0 : current.isBoutiqueExclusive) &&
                            (!currentSize || (currentSize === null || currentSize === void 0 ? void 0 : currentSize.selectable)) &&
                            !isOutOfStock &&
                            (current === null || current === void 0 ? void 0 : current.isComingSoon) != 2 &&
                            !(current === null || current === void 0 ? void 0 : current.notShoppable) &&
                            (((_l = current === null || current === void 0 ? void 0 : current.price) === null || _l === void 0 ? void 0 : _l.type) || ((_o = (_m = current === null || current === void 0 ? void 0 : current.price) === null || _m === void 0 ? void 0 : _m.sales) === null || _o === void 0 ? void 0 : _o.value)) && (React.createElement("div", { className: "product-selection__shipping" },
                            React.createElement("p", null,
                                " ",
                                !(current === null || current === void 0 ? void 0 : current.isMbm) ? t('product.freeshipping') : t('product.mbmshipping')))))) : (React.createElement(React.Fragment, null, !(current === null || current === void 0 ? void 0 : current.isComingSoon) && !isPreOrderOrExclusive && shippingDisclaimer()))),
                    !window.unshoppable &&
                        ((!(current === null || current === void 0 ? void 0 : current.isBoutiqueExclusive) &&
                            (!currentSize || (currentSize === null || currentSize === void 0 ? void 0 : currentSize.selectable)) &&
                            !isOutOfStock &&
                            (current === null || current === void 0 ? void 0 : current.isComingSoon) != 2 &&
                            !(current === null || current === void 0 ? void 0 : current.notShoppable) &&
                            (((_p = current === null || current === void 0 ? void 0 : current.price) === null || _p === void 0 ? void 0 : _p.type) || ((_r = (_q = current === null || current === void 0 ? void 0 : current.price) === null || _q === void 0 ? void 0 : _q.sales) === null || _r === void 0 ? void 0 : _r.value))) ||
                            (current === null || current === void 0 ? void 0 : current.isMbm)) &&
                        props.shippingAndReturns &&
                        !(current === null || current === void 0 ? void 0 : current.isGiftCard) && (React.createElement("div", { className: "wrapper-cta" },
                        React.createElement("button", { type: "button", className: "button--link button--arrow-right product-selection__actions-shipping__contact-us", onClick: () => {
                                props.setShippingOpen(true);
                                analytics.shippingAndReturnsLabel('', (current === null || current === void 0 ? void 0 : current.id) || (current === null || current === void 0 ? void 0 : current.masterId));
                            }, "aria-haspopup": "dialog" }, t('label.shippingandreturns')))),
                    (current === null || current === void 0 ? void 0 : current.isMbm) && (React.createElement("div", null,
                        React.createElement(BookAnAppointmentMbm, { modalimage: props === null || props === void 0 ? void 0 : props.mbmBaa, product: current }))),
                    !current.isGiftCard && showReserveInBoutiqueLink && (React.createElement("div", { className: "wrapper-cta" },
                        React.createElement(ProductReserveInBoutique, { product: current, size: currentSize, color: currentColor, sizeVariations: sizeVariations, colourVariations: colourVariations }))),
                    inLook && (React.createElement("div", { className: "wrapper-cta" },
                        React.createElement("a", { href: props.currentLook.productUrl, className: "button button--link button--arrow-right" }, t('product.showMore')))),
                    React.createElement("div", { className: "wrapper-cta" },
                        React.createElement("button", { type: "button", className: classNames('button--link button--arrow-right product-selection__actions-shipping__contact-us', { button: inLook }), onClick: () => {
                                setContactusModalOpen(true);
                                analytics.contactUsLabel((current === null || current === void 0 ? void 0 : current.id) || (current === null || current === void 0 ? void 0 : current.masterId));
                            }, "aria-haspopup": "dialog" }, t('label.contactus')))),
                (current === null || current === void 0 ? void 0 : current.hasNft) && (current === null || current === void 0 ? void 0 : current.nftContentAsset) && React.createElement(NFTInfoBox, { nftContentAsset: current === null || current === void 0 ? void 0 : current.nftContentAsset }))));
    };
    if (!inLook) {
        const callback = (entries) => {
            entries.forEach((entry) => {
                if (entry.isIntersecting) {
                    // hide
                    // console.info('hide');
                    setShowSticky(false);
                }
                else {
                    // show
                    // console.info('show');
                    setShowSticky(true);
                }
            });
        };
        const observer = useRef(new IntersectionObserver(callback, { threshold: 0 })).current;
        // intersection observer on stickyTray
        useEffect(() => {
            if (currentBreakpoint < window.mqObj.md) {
                setTimeout(() => {
                    if (productButtonRef) {
                        observer.observe(productButtonRef.current);
                        return () => observer.disconnect();
                    }
                }, 1000);
            }
            else {
                observer.observe(productSectionRef.current);
                return () => observer.disconnect();
            }
        }, [currentBreakpoint, window.mqObj, productButtonRef]);
    }
    const [selectionWrapperRef, inView] = useInView({
        triggerOnce: true,
    });
    // ANCHOR - Use Mutation Observable
    const onResize = useCallback((target) => {
        var _a;
        // Handle the resize event
        let productSelectionContent = document.querySelector('.product-selection-content');
        const headerHeight = (_a = document.querySelector('header')) === null || _a === void 0 ? void 0 : _a.offsetHeight;
        let heightContainer = window.innerHeight - headerHeight;
        if (productSelectionContent.offsetHeight <= heightContainer) {
            productSelectionContent.classList.add('center-alignment');
        }
        else {
            productSelectionContent.classList.remove('center-alignment');
        }
        let heightTarget = `calc(100vh - ${(target === null || target === void 0 ? void 0 : target.offsetHeight) / 10}rem`;
        let productSelection = document.querySelector('.product-selection');
        productSelection.style.top = heightTarget;
    }, [props.imageLoaded]);
    const containerRef = useResizeObserver(onResize, 300);
    /**
     * Renders the content of the modal
     */
    const renderDetails = () => {
        return (React.createElement("div", { className: "contact-us" },
            !window.isClothing && (React.createElement("div", { className: "contact-us__desc" },
                React.createElement("div", { className: "row justify-center" },
                    React.createElement("h2", { className: "col-12 primary-m" }, t('label.contactus')),
                    React.createElement("p", { className: "col-12 mt-16" }, t('contactus.description'))))),
            React.createElement("div", { className: classNames('contact-details contact-details--enhanced', { 'clothing-contact-details': window.isClothing }) },
                React.createElement(ContactDetailsEnhanced, { fullWidth: true, drawer: true, showEmailCta: true }))));
    };
    return (React.createElement(React.Fragment, null,
        !inLook && props.imageLoaded && (React.createElement(ProductStickyTray, { show: showSticky, current: current, currentColor: currentColor, changeColor: changeColor, currentSize: currentSize, changeSize: changeSize, colourVariations: colourVariations, sizeVariations: sizeVariations, sizeSelectorError: sizeSelectorError, updateSizeSelectorError: (e) => setSizeSelectorError(e), variantPrice: variantPrice, trackAddToBag: sendAnalytics, showReserveInBoutiqueButton: showReserveInBoutiqueButton, setSizeguideOpen: props === null || props === void 0 ? void 0 : props.setSizeguideOpen, checkouturl: props.checkouturl })),
        React.createElement("div", { ref: selectionWrapperRef, className: classNames('product-selection', { container: !inLook, landing: !current || !inView || !props.imageLoaded }) },
            React.createElement("div", { className: "product-selection-content", ref: containerRef }, inLook ? (productSelectionBody()) : (React.createElement("div", { ref: productSectionRef, className: "row justify-center align-middle" },
                React.createElement("div", { className: "col-md-12 col-sm-8 col-12 wrapper-body-detail mq-large-case-width mq-large-case-height" }, productSelectionBody()))))),
        React.createElement(Drawers, { contentLabel: t('label.contactus'), isOpen: contactusModalOpen, role: "dialog", onRequestClose: () => {
                if (location.search.includes('openVTO'))
                    analytics.vtoPdpClose();
                setContactusModalOpen(false);
            } }, renderDetails())));
};
ProductSelection.defaultProps = {
    imageLoaded: true,
};
export default ProductSelection;
